import WebServiceRequest from '../Api/WebServiceRequest'

class CreateIncrementalRatio extends WebServiceRequest {
  constructor(context) {
    super(context)
    super.setTag('ProductFeatureCountIncrementPercents/Create')
  }

  setParams(data) {
    super.setRequestParamDataObj(data)
  }
}

class DeleteIncrementalRatio extends WebServiceRequest {
  constructor(context) {
    super(context)
    super.setMethod('DELETE')
  }

  setId(id) {
    super.setTag(`ProductFeatureCountIncrementPercents/Delete/${id}`)
  }
}

class GetAllIncrementalRatioByProductId extends WebServiceRequest {
  constructor(context) {
    super(context)
    super.setMethod('GET')
    super.setTag('ProductFeatureCountIncrementPercents/GetByProductId')
  }

  setParams(data) {
    super.setRequestParam(data)
  }
}

export {
  CreateIncrementalRatio,
  DeleteIncrementalRatio,
  GetAllIncrementalRatioByProductId,
}
